<template>
  <v-expand-transition>
    <div v-show="show">
      <v-expand-transition>
        <div class="info-bar" v-show="show">
          <i18n path="message.externalChanges.summaryInfoBar" tag="div">
            <template v-slot:changesCount>
              <router-link :to="{ name: 'external-changes-protect' }">{{
                changesCountLabel
              }}</router-link>
            </template>
          </i18n>
          <ui-button
            :loading="rejectInProgress"
            class="ml-4"
            small
            @click="confirmRejection()"
            >{{ $t("message.externalChanges.rejectChanges") }}</ui-button
          >
        </div>
      </v-expand-transition>
      <div class="pb-10"></div>
    </div>
  </v-expand-transition>
</template>

<script>
import externalChangesSummary from "@/helpers/mixins/external-changes-summary";

export default {
  name: "ExternalChangesInfoBar",
  mixins: [externalChangesSummary],
  data: () => ({
    show: false
  }),
  mounted() {
    this.show = true;
  }
};
</script>

<style lang="scss" scoped>
.info-bar {
  padding: $spacing $spacing * 2;
  background: $secondary;
  color: $light;
  @include font-size(14px);
  line-height: 28px;
  display: flex;
  position: fixed;
  width: 100%;
  z-index: 4;
}
</style>
